/*
 * Navigation bevhaior for desktop.
 */
var NavController = (function ($) {

    var win, doc, nav;

    function ready() {
        if (BreakpointController.isMobile()) {
            return;
        }
        win = $(window);
        doc = $(document.body);
        nav = $("nav.main");

        //mouse
        doc.on('mouseover', onMouseOver);

        //keyboard
        doc.on('focus', 'nav.main > ul > li > div  a', onSectionFocusA);
        doc.on('click', 'nav.main ul li button.keyboardmenuaccess', onSectionFocusShowMenu);
        doc.on('keydown', 'nav.main ul li button.keyboardmenuaccess', onSectionFocusShowMenu);
        doc.on('focus', 'nav.main ul li button.keyboardmenuaccess', onSectionFocusHideMenu);
        doc.on('focus', 'nav.main > ul > li > a', onSectionFocus);
        doc.on('focusout', "nav.main > ul > li:last-child div li:last-child a", onLeaveNav);
       

        var hrefProp = "";
        $(".utility").find("a").each(function () {
            hrefProp = $(this).attr("href");
            if (hrefProp) {
                if (hrefProp.indexOf("http://tel") !== -1)
                    $(this).attr('href', hrefProp.substring(7));

                if (hrefProp.indexOf("https://tel") !== -1)
                    $(this).attr('href', $(this).attr("href").substring(8));
            }
        });
    }

    function onMouseOver(e) {
        //If not within the menu, get rid of "hover" classes
        if ($(this).closest('nav.main').length === 0) {
            nav.find('.hover').removeClass('hover');
        }
    }
    
    //Focus Button
    function onSectionFocusHideMenu(e) {
        
        //No sub menu for me
        event.preventDefault();
        var mysubmenu = $(this).siblings("div");
        var mymenuitem = mysubmenu.closest("li");

        mymenuitem.siblings().removeClass('hover');
        mymenuitem.removeClass('hover');
        
        mysubmenu.find('a').each(function() {
            $(this).attr("tabindex", "-1");
            
        });
        
    }

    //Enter Button Hit or Down Arrow
    function onSectionFocusShowMenu(e) {
        //I want to see the submenu and tab through
        if (e.which === 40 || e.which === 13) { //down arrow or enter
            event.preventDefault();
            var mysubmenu = $(this).siblings("div");
            var mymenuitem = mysubmenu.closest("li");
                
            mymenuitem.siblings().removeClass('hover');
            mymenuitem.addClass('hover');
            mysubmenu.find('a').each(function () {
                $(this).attr("tabindex", "0");
            });
        }
    }

    //Submenu Link Focus
    function onSectionFocusA(e) {
        $(this).closest('nav.main > ul > li').siblings().removeClass('hover');
        $(this).closest('nav.main > ul > li').addClass('hover');
    }   

    //Move away from submenu
    function onSectionFocus(e) {
        var mysubmenu = nav.find("li.hover > div");
        nav.find("li").removeClass('hover');
        mysubmenu.find('a').each(function () {
            $(this).attr("tabindex", "-1");
        });
    }

    function onLeaveNav(e) {
        var mysubmenu = $(this).closest("li.hover");
        mysubmenu.removeClass('hover');
    }


   $(ready);

})(jQuery);